<section class="ip-table" *ngIf="data">
  <div class="ip-table__top" *ngIf="!onlyTable">
    <span class="ip-table__top--title" *ngIf="tableTitle">{{
      tableTitle | translate
    }}</span>
    <div class="ip-table__top--fn_inputs" *ngIf="!billed && optionalTitle">
      <div>
        <span class="ip-table__top--fn_inputs_title">{{
          optionalTitle | translate
        }}</span>
      </div>

      <!-- <div
        class="ip-table__top--fn_inputs__mobile-filters"
        *ngIf="this.service !== 'supplier-accounts'"
      >
        <button (click)="openFiltersModal()">
          <span class="ip-table__top--fn_inputs__mobile-filters__span"
            >Filtrar</span
          >
          <img
            src="../../../../assets/icons/filters-icon.svg"
            alt=""
          />
        </button>
      </div> -->

      <ng-container *ngIf="mode === 'side'" [ngTemplateOutlet]="filters"></ng-container>
      <button 
        class="ip-table__btn"
        *ngIf="mode === 'over'"
        (click)="openDialog()">
        <mat-icon class="ip-table__btn-icon">search</mat-icon> 
        <span>{{ "IP.FILTERS_MODAL.FILTER" | translate }}</span> 
      </button>
    </div>
    <div class="ip-table__top-option" *ngIf="!billed && !optionalTitle && !noTopOptions">
      <ul class="ip-table__top-option-filters">
        <ng-container *ngIf="service !== 'invoice-paid'">

        <button
          class="ip-table__top-option-filters--button"
          *ngFor="let select of tableOption.selects; let i = index"
          mat-button
          [ngClass]="{
            selected: i == currentSelect,
            unselected: i != currentSelect
          }"
          (click)="toggleSelect(i, select)"
        >
          {{ select[0] | translate }}
        </button>
        </ng-container>
      </ul>
      <div
        class="ip-table__top-option-search{{ tableTitle ? '' : '__only' }}"
        *ngIf="
          service !== 'subsidiaries' &&
          service !== 'user-management' &&
          service !== 'admin-management' &&
          service !== 'employee-management' &&
          service !== 'supplier-users'
        "
      >
        <div
          class="ip-table__top-option-search{{
            tableTitle ? '' : '__only'
          }}-input"
        >
          <span
            class="ip-table__top-option-search-filter"
            *ngIf="filter"
            [style.background-image]="
              'url(assets/img/ip-table-dashboard/filter.svg)'
            "
            (click)="toggleFilter(true)"
          ></span>
          <div
            class="ip-table__top-option-search-filters"
            *ngIf="filter && showFilter && mode === 'side'"
          >
            <app-ip-filters
              [service]="service"
              (close)="toggleFilter(false)"
              [filters]="tableOption.filters || []"
              [filterValues]="this.filterValues"
              (applyFilters)="setFilters($event)"
              [onlyLast30days]="this.onlyLast30days"
            >
              ></app-ip-filters
            >
          </div>
          <!-- <app-ip-modal-mobile [showTitle]="false" [showCloseModal]="false" *ngIf="filter && showFilter && mode === 'over'">
            <app-ip-filters
              [service]="service"
              (close)="toggleFilter(false)"
              [filters]="tableOption.filters || []"
              [filterValues]="this.filterValues"
              (applyFilters)="setFilters($event)"
              [onlyLast30days]="this.onlyLast30days"
            >
              ></app-ip-filters
            >
          </app-ip-modal-mobile> -->
        </div>
      </div>
    </div>
  </div>

  <div
    class="ip-table__table-searchbox"
    *ngIf="this.service === 'supplier-accounts'"
  >
    <app-fn-search-input
      *ngIf="this.service === 'supplier-accounts'"
      (onSearch)="this.onSearch($event)"
    >
    </app-fn-search-input>
  </div>

  <div class="ip-table__table" *ngIf="data.length">
    <app-table
      *ngIf="data.length && mode === 'side'"
      class="ip-table__table--desktop"
      [data]="data"
      [keyTranslate]="tableOption.keyTranslate"
      [actions]="tableOption.actions"
      tableStyle="invopay"
      (sort)="onSortTable($event)"
      (action)="onActionTable($event)"
      [propertyOrder]="propertyOrder"
      [scroll]="scroll"
      [isForSelectItem]="isForSelectItem"
      (selectedItemsChange)="onSelect($event)"
      (selectedAllItems)="onSelectAll($event)"
      [clearSelection]="shouldClear"
    ></app-table>
    <!-- <app-card-table
      *ngIf="data.length && mode === 'over'"
      class="ip-table__table--mobile"
      [dataCard]="data"
      [service]="this.service"
      [actions]="tableOption.actions"
      [keyTranslate]="tableOption.keyTranslate"
      (action)="onActionTable($event)"
    >
    </app-card-table> -->
    <app-mobile-card-list
      *ngIf="cardConfig && data.length && mode === 'over'"
      [data]="data"
      [config]="cardConfig"
      (action)="onActionTable($event)">
    </app-mobile-card-list>
    <app-paginator
      *ngIf="data && totalItems > pageItems"
      [currentPages]="currentPage + 1"
      [itemsPerPage]="pageItems"
      [totalItems]="totalItems"
      (pageChange)="onPageChange($event)"
    ></app-paginator>
  </div>
  <div *ngIf="data">
    <app-no-data *ngIf="!data.length" [service]="service"></app-no-data>
  </div>
</section>

<ng-template #modalFilters *ngIf="mode === 'over'">
  <app-ip-modal-mobile [showCloseModal]="false" [title]="'Buscar pagos'">    
    <ng-container [ngTemplateOutlet]="filters"></ng-container>
  </app-ip-modal-mobile>
</ng-template>

<ng-template #filters>
  <div class="ip-table__top--fn_inputs-filters">
        <form
          [formGroup]="filterForm"
          class="ip-table__top--fn_inputs-filters_dates-form"
          *ngIf="this.service !== 'supplier-accounts'"
        >
        <div class="ip-table__top--fn_inputs-filters_dates">
        </div>
          <div class="ip-table__top--fn_inputs-filters_dates" *ngIf="filtersForPayIn">
            <app-ip-input
            [control]="originOwner"
            [label]="'IP.TABLE.CONSOLIDATED.PAY_IN.ORIGINOWNER' | translate"
            [type]="'text'"
            inputId="originOwner"
            ></app-ip-input> 
          </div>
          <div class="ip-table__top--fn_inputs-filters_dates" *ngIf="filtersForPayIn">
            <app-ip-input
            [control]="originBank"
            [label]="'IP.TABLE.CONSOLIDATED.PAY_IN.ORIGINBANK' | translate"
            [type]="'text'"
            inputId="originBank"
            ></app-ip-input> 
          </div>
          <div class="ip-table__top--fn_inputs-filters_dates">
            <app-ip-date-input
            [control]="creationDate"
            inputId="createDateFrom"
            (changed)="onStartDateChange()"
            [max]="maxDate"
            [label]="'IP.SETTLEMENTS.SALE-PAYMENT.FILTERS.FROM' | translate"
            #startDateInput></app-ip-date-input>
          </div>
          <div class="ip-table__top--fn_inputs-filters_dates">
            <app-ip-date-input
            [control]="dueDate"
            inputId="createDateTo"
            (changed)="onEndDateChange()"
            [min]="minEndDate"
            [max]="maxEndDate"
            [label]="'IP.SETTLEMENTS.SALE-PAYMENT.FILTERS.TO' | translate"
            #dueDateInput></app-ip-date-input>
          </div>
        </form>
        <div class="ip-table__top--fn_inputs-filters_search" *ngIf="searchField">
          <app-ip-search-input
            #searchInput
            [hidePrefix]="true"
            [placeholder]="'Buscar'"
            (onSearch)="this.onSearch($event)"
          ></app-ip-search-input>
          <button
            class="ip-table__top--fn_inputs-filters_search-btn"
            (click)="executeService(searchInput.searchValue)"
            *ngIf="this.service !== 'supplier-accounts'"
          >
            <img
              src="../../../../assets/new-styles/icons/buttons/search-icon-white.svg"
              alt=""
            />
          </button>
        </div>
        <div class="ip-table__top--fn_inputs-filters_search" *ngIf="!searchField">
          <app-ip-button-modal
            typeBtn="action"
            (clicked)="executeService()"
            [matTooltip]="'IP.SETTLEMENTS.SALE-PAYMENT.FILTERS.SEARCH' | translate"
            matTooltipPosition="above"
            [size]="'small'"
            [disabled]="creationDate.value === '' || dueDate.value === '' || creationDate.value > dueDate.value"
            *ngIf="this.service !== 'supplier-accounts'"
            >
            <img
            class="ip-table__top--fn_inputs-filters-icon"
            src="assets/icons/search.svg"
          />
        </app-ip-button-modal>
        </div>
      </div>
</ng-template>
